module.exports = __webpack_public_path__ + "static/media/14x18no2.9f558f84.jpg";